
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { isDesktop } from '@/helpers/isDesktop';
import type { PMSubPhase } from '@/models/pmsubphase';
import { pmSubPhaseWebservice } from '@/webservices/pmsubphase';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';
import { showErrorNotification } from '@/helpers/showErrorNotification';

@Component({
    name: 'FormSubphasePicker',
})
export default class FormSubphasePicker extends Vue {
    @Model('input', {
        required: true,
    })
    private subphases: PMSubPhase[];

    @Prop({
        required: false,
        default: () => [],
    })
    private availableSubphases: PMSubPhase[];

    @Prop({
        required: true,
    })
    private phaseId: number;

    @Prop({
        required: false,
        default: ApprovalState.ALL,
    })
    private approvalState: ApprovalState;

    @Prop({
        required: false,
        default: false,
    })
    private preselected: boolean;

    @Prop({
        required: false,
        default: () => false,
    })
    private subPhaseIsSet: boolean;

    private disabled: boolean = false;

    private defaultSubphases: PMSubPhase[] = [];

    private isDesktop = isDesktop();

    mounted() {
        if (this.availableSubphases.length === 0) {
            this.loadOptions();
        }
        // if (this.subPhaseIsSet) {
        //     this.disabled = true;
        // }
    }

    loadOptions() {
        pmSubPhaseWebservice
            .load(this.phaseId, this.approvalState)
            .then((response) => {
                this.defaultSubphases = response.data;
            })
            .catch(() => {
                showErrorNotification('');
            });
    }

    get selected() {
        // Return first sub-phase in case `preselected` is true,
        // and not already selected
        if (!this.subphases && this.preselected && this.defaultSubphases[0]) {
            const preselectedSubPhase = this.defaultSubphases[0];

            // We need to emit input because parent element
            // uses vue v-bind directive to bind input on this component
            this.$emit('input', preselectedSubPhase);

            return preselectedSubPhase;
        }

        return this.subphases;
    }

    get available() {
        return this.availableSubphases.length > 0 ? this.availableSubphases : this.defaultSubphases;
    }
}
